import React from "react";
import { eventLabels, statusLabels } from "../constants";
import OrderDisclosure from "./OrderDisclosure";
import HistoryChanges from "./HistoryChanges";

function HistoryEntry({ event, documentLabels, latest }) {
  const changes = (event.changes || []).filter(
    (change) => change.field !== "reviewNote",
  );
  const note = event.changes?.find((change) => change.field === "reviewNote");
  const email = event.actorId && event.actorEmail;
  const actor = event.actorId
    ? event.actorName || `Użytkownik ${event.actorId}`
    : event.actorId === null
      ? "System"
      : "Autor nieznany";
  return (
    <li data-kind={event.kind}>
      <div className="premium-history-heading">
        <strong>{eventLabels[event.kind] || event.kind}</strong>
        <time dateTime={event.at}>
          {new Date(event.at).toLocaleTimeString("pl-PL")}
        </time>
      </div>
      <div className="premium-history-meta">
        {(!email || event.actorName) && (
          <span className="premium-history-author" title={event.actorId || undefined}>
            <i className={`bi ${event.actorId === null ? "bi-gear" : "bi-person"}`} aria-hidden="true" />{" "}
            {actor}
          </span>
        )}
        {email && (
          <span className="premium-history-email">
            <i className="bi bi-envelope" aria-hidden="true" />
            <span>{email}</span>
          </span>
        )}
        {event.fileCount != null && (
          <span>Liczba plików: {event.fileCount}</span>
        )}
        {event.stage && <span>{statusLabels[event.stage] || event.stage}</span>}
      </div>
      {event.reread && <p>Zlecono ponowny odczyt dokumentów.</p>}
      {note && (
        <OrderDisclosure
          title="Notatka z weryfikacji"
          icon="bi-chat-left-text"
          variant="note"
        >
          <p>{note.after || "Usunięto notatkę."}</p>
          {note.before && (
            <details>
              <summary>Poprzednia treść notatki</summary>
              <p>{note.before}</p>
            </details>
          )}
        </OrderDisclosure>
      )}
      {event.kind === "corrected" && !event.changes && (
        <p className="small text-muted">
          Brak szczegółów tej korekty w zapisanej historii.
        </p>
      )}
      {changes.length > 0 && (
        <OrderDisclosure
          variant="audit"
          title="Szczegóły zmian"
          icon="bi-list-ul"
          count={changes.length}
          open={latest}
        >
          <HistoryChanges changes={changes} documentLabels={documentLabels} />
        </OrderDisclosure>
      )}
    </li>
  );
}

export default function OrderHistory({ events, documentLabels }) {
  const days = new Map();
  for (const event of events.slice().reverse()) {
    const day = new Date(event.at).toLocaleDateString("pl-PL", {
      dateStyle: "long",
    });
    if (!days.has(day)) days.set(day, []);
    days.get(day).push(event);
  }
  return (
    <OrderDisclosure
      title="Historia zlecenia"
      icon="bi-clock-history"
      count={events.length}
    >
      {events.length ? (
        Array.from(days, ([day, entries]) => (
          <section key={day} className="premium-history-day">
            <h3>{day}</h3>
            <ol
              className="premium-history-list"
              aria-label={`Zdarzenia z dnia ${day}`}
            >
              {entries.map((event, index) => (
                <HistoryEntry
                  key={event.id || index}
                  event={event}
                  documentLabels={documentLabels}
                  latest={event === events[events.length - 1]}
                />
              ))}
            </ol>
          </section>
        ))
      ) : (
        <p className="mb-0 text-muted">Brak wpisów w historii zlecenia.</p>
      )}
    </OrderDisclosure>
  );
}
